<template>
  <div id='order'>
        <NavTop title='确认订单' :islink='true' linkurl='/index'/>
        <van-cell-group inset>
                    <van-cell is-link to="/addresslist/dorder" title-class="address_title" value-class="address_label" v-if='isSetAddr'>
                        <template #title>
                            <van-icon name="location-o" /><span class='address_con'>{{choosedAddr.province}}{{choosedAddr.city}}{{choosedAddr.county}}{{choosedAddr.addressdetail}}</span>
                        </template>
                        <template #label>
                            {{choosedAddr.name}} {{choosedAddr.tel}}
                        </template>        
                    </van-cell>
                    <van-cell is-link to="/addresslist/dorder" title-class="address_empty" value-class="address_label" v-else>
                        <template #title>
                            <van-icon name="add-o"  size="0.6rem" /><span class='address_add'>添加邮寄地址</span>
                        </template>     
                    </van-cell>
        </van-cell-group>  
        <van-cell-group inset>
           <van-cell>
               <template #title>
                 <div class='cellitem'>
                    <div class='celltitle'>订单详情</div>
                    <div class='cellright'>未付款</div>
                  </div>
                  <div class='goodsitem'>
                        <div class='cellitem'>
                              <div class='goodsimg'><img :src='goodsinfo.headimg'/></div>
                              <div class='info'>
                                  <div class="info-line">{{goodsinfo.name}}</div>
                                  <div class="info-line-small">{{goodsinfo.detail}}</div>
                                  <div class="info-line-bottom">
                                    <div class="info-line">优惠价:¥{{goodsinfo.price}}</div>
                                     <div class="info-line-bottom-right">X 1</div>
                                  </div>
                              </div>
                        </div> 
                        <div class='cellitem' v-if="coupontotal>0">
                            <div class='celltitle'>优惠抵扣</div>
                            <div class='cellright red'>-{{coupontotal}}元</div>
                        </div>     
                  </div>   
               </template>   
           </van-cell> 
        </van-cell-group> 
        <van-submit-bar>
            <div class="bottomcon-left"><div class="goodswords">优惠总价:</div><div class="goodsprice">¥{{realmoney}}</div></div>
            <template #button>
                <div class="bottomcon-right">
                      <div class="bottomcon-btn-sure" @click="onSubmit">去支付</div>
                </div>
            </template>
        </van-submit-bar>    
  </div>
</template>
<script>
import { SubmitBar,Cell, CellGroup,Icon} from 'vant';
import NavTop from '@/components/navtop'

export default {
   name: 'order',
   data() {
      return {
          goodsinfo:[],
          processing:false,
          coupontotal:0
      }
   }, 
   computed:{
      isSetAddr(){
          return Object.keys(this.$store.state.address.choosedaddress).length===0 ? false :true
      },
      choosedAddr(){
          return this.$store.state.address.choosedaddress
      },
      dgoodsid(){
          return this.$store.state.cart.dgoodsid
      },
      realmoney(){
          return parseInt(this.goodsinfo.price)-parseInt(this.coupontotal)
      }
   },
   created(){
      this.getList()
   },
   methods: {
      getList(){ 
           if(!this.isSetAddr){
                this.$post("/address/getDefaultAddr",{}).then((data)=>{
                if(data.result.success) { 
                    this.$store.commit("SET_ADDRESS",{address:data.result.info})
                }
              })
           }
           if(this.dgoodsid!=0 && this.dgoodsid!=undefined){
                this.$post("/order/getDGoodsInfo",{goodsid:this.dgoodsid}).then((data)=>{
                    if(data.result.success){
                        this.goodsinfo=data.result.info
                        this.getCouponMoney()
                    }else{
                        this.$toast(data.result.info)
                    }
                })
           }else{
               this.$toast("网络繁忙，请稍后再试")
               this.$go("/dgoodslist")
           }
      },
      getCouponMoney(){
          this.$post("/coupon/getCouponMoney",{realmoney:this.goodsinfo.price}).then((data)=>{
            if(data.result.success){
                this.coupontotal=data.result.info
            }else{
                this.$toast("系统繁忙，请稍后再试");
                this.go("/index")
            }
         })
      },
      onSubmit(){
            if(!this.isSetAddr){
                this.$toast("请先设置收货地址");
                return false;
            }
            if(this.dgoodsid==0 || this.dgoodsid==undefined){
                this.$toast("网络繁忙，请稍后再试")
            }
            if(this.processing){
                this.$toast("请耐心等待提交完成");
                return false;
            }
            let orderinfo={}
            orderinfo['goodsinfo']=this.goodsinfo
            orderinfo["total"]=this.goodsinfo.price
            orderinfo["addressinfo"]=this.$store.state.address.choosedaddress
            orderinfo["realmoney"]=this.realmoney
            orderinfo["coupontotal"]=this.coupontotal
            this.processing=true
            this.$post("/order/Dorder",{orderinfo:orderinfo}).then((data)=>{
                this.processing=false
                if(data.result.success){ 
                    this.$go("/payment/"+data.result.info)
                }else{
                    this.$toast(data.result.info)
                }
            })
            
      }
   },
   components: {
        [SubmitBar.name]: SubmitBar ,
        [Cell.name]: Cell ,
        [CellGroup.name]: CellGroup ,
        [Icon.name]: Icon ,
        NavTop
   }
}
</script>
<style scoped>
#order{background-color:#F6F6F6;min-height: 100vh;padding-bottom: 85px;}
.address_title{flex:4;text-align: left;}
.address_value{flex:1;}
.address_title_short{flex:2;text-align: left;}
.address_value_long{flex:4;}
.address_empty{display: flex;align-items: center;}
.address_add{padding-left:0.2rem;}
.address_con{margin-left:0.1rem;}
.title{color:#cccccc;text-align: left;}
.goodsitem{display: flex;flex-direction: column;}
.goodsimg{width:3.5rem;}
.goodsimg img{width:100%;width:2rem;height:2rem;}
.info{margin-left: 0.3rem;width:100%;display: flex;flex-flow: column nowrap;}
.info-line{font-size:0.35rem;text-align: left;}
.info-line-small{font-size:0.3rem;text-align: left;}
.info-line-bottom{display: flex;}
.info-line-bottom-left{font-size:0.30rem}
.info-line-bottom-right{margin-left: auto;}
.cellitem{display: flex;flex-direction: row;margin-top: 0.15rem;}
.line{display: flex;flex-direction: row;}
.price{margin-left:auto;font-size:0.35rem;}
.dashprice{margin-left:auto;color:#cccccc;text-decoration: line-through;font-size:0.3rem;}
.cellright{margin-left:auto;color:#969799}
.subprice{color:#bbbbbb;font-size:0.3rem;}
.goodstitle{font-size:0.35rem;font-weight: 600;}
::v-deep .van-cell-group--inset{margin-top: 0.3rem;}
.bottomcon-left{display: flex;margin-right: auto;}
.goodswords{color:#333;font-size:0.35rem}
.goodsprice{color:#ff3600;font-size:0.4rem;display: flex;align-items: center;}
.bottomcon-right{display: flex;}
.bottomcon-btn-cancel{background-color:#ccc;color:#333;height:1rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;margin-right: 0.1rem;}
.bottomcon-btn-sure{background-color:#ee0a24;color:#fff;height:1rem;width:2rem;border-radius: 0.15rem;display: flex;flex-flow: column nowrap;justify-content: center;}
.red{color:#ee0a24}

</style>